import React from 'react';
import styles from './AiInsightsBanner.module.css';
import { getFileIcon } from '../../../Helpers/fileIcon';

export interface AiInsightsBannerProps {
  selectedFiles: Array<{ id: string; fileName: string }>;
  /** `footer` removes standalone chrome so the banner can sit flush in a panel. */
  variant?: 'standalone' | 'footer';
}

const AiInsightsBanner: React.FC<AiInsightsBannerProps> = ({
  selectedFiles,
  variant = 'standalone',
}) => {
  return (
    <div className={variant === 'footer' ? styles.bannerFooter : styles.banner}>
      <div className={styles.left}>
        <img src="/img/sparkle-blue.svg" alt="" className={styles.sparkleIcon} />
        <p className={styles.label}>
          {variant === 'footer'
            ? 'AI insights sourced from selected evidence:'
            : 'AI insights sourced from selected evidence:'}
        </p>
        <div className={styles.badges}>
          {selectedFiles.length > 0 ? (
            selectedFiles.map((file) => (
              <span key={file.id} className={styles.fileChip} title={file.fileName}>
                <img src={getFileIcon(file.fileName)} alt="" className={styles.fileIcon} />
                <span className={styles.fileName}>{file.fileName}</span>
              </span>
            ))
          ) : (
            <span className={styles.noSources}>No evidence selected</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiInsightsBanner;
